import { compose } from 'redux';

const rootState = (state) => {
  return state.config;
};

export const getConfigLoading = compose((configState) => {
    return configState.loading;
  }, rootState);